export const FabIcons = [
  { name: "Youtube", icon: "fa-youtube" },
  { name: "Google", icon: "fa-google" },
  { name: "Facebook", icon: "fa-facebook" },
  { name: "LinkedIn", icon: "fa-linkedin" },
  { name: "Whatsapp", icon: "fa-whatsapp" },
  { name: "Amazon", icon: "fa-amazon" },
  { name: "Airbnb", icon: "fa-airbnb" },
  { name: "Apple", icon: "fa-apple" },
  { name: "Behance", icon: "fa-behance" },
  { name: "Deezer", icon: "fa-deezer" },
  { name: "Deviantart", icon: "fa-deviantart" },
  { name: "Discord", icon: "fa-discord" },
  { name: "Dribbble", icon: "fa-dribbble" },
  { name: "Github", icon: "fa-github" },
  { name: "Kickstarter", icon: "fa-kickstarter" },
  { name: "Lastfm", icon: "fa-lastfm" },
  { name: "Line", icon: "fa-line" },
  { name: "Lyft", icon: "fa-lyft" },
  { name: "Meetup", icon: "fa-meetup" },
  { name: "Medium", icon: "fa-medium" },
  { name: "Microsoft", icon: "fa-microsoft" },
  { name: "Npm", icon: "fa-npm" },
  { name: "Patreon", icon: "fa-patreon" },
  { name: "PayPal", icon: "fa-paypal" },
  { name: "Pinterest", icon: "fa-pinterest" },
  { name: "Playstation", icon: "fa-playstation" },
  { name: "Quora", icon: "fa-quora" },
  { name: "Product-Hunt", icon: "fa-product-hunt" },
  { name: "Reddit", icon: "fa-reddit" },
  { name: "RocketChat", icon: "fa-rocketchat" },
  { name: "SalesForce", icon: "fa-salesforce" },
  { name: "Skype", icon: "fa-skype" },
  { name: "Slack", icon: "fa-slack" },
  { name: "Slideshare", icon: "fa-slideshare" },
  { name: "Snapchat", icon: "fa-snapchat" },
  { name: "Spotify", icon: "fa-spotify" },
  { name: "Squarespace", icon: "fa-squarespace" },
  { name: "Stack Overflow", icon: "fa-stack-overflow" },
  { name: "Steam", icon: "fa-steam" },
  { name: "Telegram", icon: "fa-telegram" },
  { name: "TikTok", icon: "fa-tiktok" },
  { name: "Trello", icon: "fa-trello" },
  { name: "Tumblr", icon: "fa-tumblr" },
  { name: "Twitch", icon: "fa-twitch" },
  { name: "Twitter", icon: "fa-twitter" },
  { name: "Unsplash", icon: "fa-unsplash" },
  { name: "Twitter", icon: "fa-twitter" },
  { name: "Viber", icon: "fa-viber" },
  { name: "Vine", icon: "fa-vine" },
  { name: "VK", icon: "fa-vk" },
  { name: "Wix", icon: "fa-wix" },
];